/**
 * @module AriaDataPoint
 */

import { CLIENT_TYPE } from '../constants';
import { AriaDataType, AriaDataMap } from '../types/AriaDataPointTypes';
import getClientVersion from '../utils/getClientVersion';
import { getUserConfiguration } from 'owa-session-store';
import { getForest, getClientId, getSessionId } from 'owa-config';
import { getPhysicalRing } from 'owa-metatags';

/**
 * @class AriaDataPoint
 */
export default class AriaDataPoint {
    /**
     * @private
     * A member to hold all the data point properties
     */

    private properties: AriaDataMap = {};

    /**
     * @constructor
     * To create an instance of Aria data point
     * @returns An instance of AriaDataPoint
     */

    constructor() {
        const sessionSettings = getUserConfiguration().SessionSettings || {};
        this.properties.clientType = CLIENT_TYPE;
        this.properties.clientVersion = getClientVersion();
        this.properties.forest = getForest();

        /**
         * In order to be GDPR complaint, we need to log the PUID in UserInfo.Id
         * so we can scrub the user's data if they request it.
         */
        this.properties['UserInfo.Id'] = sessionSettings.UserPuid;

        this.properties.clientId = getClientId();
        this.properties.tenantGuid = sessionSettings.ExternalDirectoryTenantGuid;
        this.properties.sessionId = getSessionId();
        this.properties.physicalRing = getPhysicalRing();
    }

    /**
     * @protected
     * @param {string} key - A key of the property
     * @param {AriaDataType} value - A value of the property
     * @return Nothing
     */

    protected setProperty(key: string, value: AriaDataType): void {
        this.properties[key] = value;
    }

    /**
     * @public
     * To get the list of properties
     * @returns A list of data point properties
     */

    public getProperties(): AriaDataMap {
        return this.properties;
    }
}
